import {ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output} from '@angular/core'
import { Stringable, StringableValues } from '../../../../../common/stringable.decorator'
import { Router,ActivatedRoute } from '@angular/router'

import { PanierLine } from '../../../../../Interfaces/Panier'
import { JSONRpcResponse } from '../../../../../Interfaces/JSONRpcResponse'
import { DossierService,TiersService,StateService } from '../../../../../services'

const KEY = 'dossier-page-recherche-result'
@Component({
	selector: 'atyl-recherche-result',
	templateUrl: './recherche-result.component.html',
	styleUrls: ['./recherche-result.component.scss'],
})
@Stringable({
	path: 'views/pages/recherche/result',
	key: KEY,
})
export class RechercheResultComponent implements OnInit {

	@Input() result: any = {};
	@Input() loading: boolean = false;
	@Output() onPageClicked = new EventEmitter<any>();
	@Output() onRowClicked = new EventEmitter<any>();
	@Output() onHeaderClicked = new EventEmitter<any>();
	@Output() onExportClicked = new EventEmitter<string>();
	@StringableValues(KEY) strings: any

	inited = new EventEmitter<any>();
	
	disabledPanier:boolean=true;
	elementPanier:PanierLine[]=[];
	
	@Input() isExportPDF:boolean=false;
	@Input() isExportCSV:boolean=false;
		
	IsOpenID: boolean = false;
	
	constructor(
		private stateService: StateService,
		private changeDetectorRef: ChangeDetectorRef,
		private dossierService:DossierService,
		private tiersService: TiersService,
		private router: Router,
		private activatedRoute: ActivatedRoute,		
				
	) { }

	ngOnInit() {
		
		this.stateService.openid.subscribe((openid:boolean) => {
					this.IsOpenID=openid;
		})
	}
	onPaged(event: any) {

		this.onPageClicked.emit(event)
		this.changeDetectorRef.detectChanges()
	}
	rowClicked(event: any) {

		this.onRowClicked.emit(event)
	}
	headerClicked(event: any) {

		this.onHeaderClicked.emit(event)
	}
	checkLoaded(load: any) {

		this.inited.emit(this.result.currentValue)
		this.changeDetectorRef.detectChanges()
	}

	getInitedEmitter() {

		return this.inited
	}
	
	selectChanged(event) {

		this.disabledPanier=true;
		this.elementPanier = []
		let _options ={
			demande: false
		}
		let oo:any[]=Object.keys(event);
		let cpt:number=0;
		Object.keys(event).forEach(key => {
			this.dossierService.get(key,_options).subscribe(
				(res: JSONRpcResponse) => {
					if (res.result && res.result.tiers) {
						let line:PanierLine=new PanierLine();
                        if (res.result.tiers!=undefined){
                            line.dossier=res.result.tiers;
                        } else {
                            console.log("object.demande non défini")
                        }
					    this.elementPanier.push(line);
					    cpt++;
					    if (cpt==oo.length)
					   		this.disabledPanier=false;
					   		
					    this.changeDetectorRef.detectChanges();
					}
				}
			)
		} );
       	this.changeDetectorRef.detectChanges();
	}
  exporter(format:string) {
	 this.onExportClicked.emit(format);
  }
  
  openID() {
	this.tiersService.connectByOpenID().subscribe(
		(res: JSONRpcResponse) => {
			if (res.result) {
				if (res.result.auth_point!=undefined && res.result.auth_point ) {
									
				//	window.location.href=res.result.auth_point;
					
				
					const popup = window.open(res.result.auth_point, 'OpenID','width=550,height=400,left=150,top=200,toolbar=0,status=0,location=no');
										
					window.addEventListener('message', (event) => {
					    if (event.data!==undefined
							&& event.data.type!==undefined 
							 && event.data.type === 'popup_closing') {
					        console.log("RechercheListComponent openid closed",event)
							
							if (event.data.ID!==undefined && event.data.tiers_type!==undefined ) {
								this.router.navigate([`/home/dossier/${event.data.tiers_type}/${event.data.ID}`], {
								          //  this.router.navigate([`/home/dossier/${row.id}`], {
								            
								            	relativeTo: this.activatedRoute,
								})
							}
							
					        // Handle cleanup
					    }
					});
				
				}
			
			}
		}	
	);
			
  }
}
